import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { UserButton } from '@clerk/clerk-react';
import {
  BookCopy,
  BookOpen,
  Bot,
  Calculator,
  LayoutDashboard,
} from 'lucide-react';

const Navbar = () => {
  const appLinks = [
    { label: 'Overview', to: '/main', icon: LayoutDashboard },
    { label: 'Learn', to: '/intro', icon: BookOpen },
    { label: 'Cases', to: '/cases', icon: BookCopy },
    { label: 'Math', to: '/math', icon: Calculator },
    { label: 'AI coach', to: '/ai', icon: Bot },
  ];

  return (
    <nav className="ap-app-nav">
      <div className="ap-app-nav-inner">
        <Link to="/main" className="ap-app-brand">
          <img src="/images/ap_logo.svg" alt="" />
          <span>Aurora Prep</span>
        </Link>

        <div className="ap-app-nav-links" aria-label="Application navigation">
          {appLinks.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => isActive ? 'is-active' : ''}
              >
                <Icon size={16} />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </div>

        <div className="ap-app-nav-actions">
          <span className="ap-app-plan"><i /> Preparation workspace</span>
          <UserButton
            afterSignOutUrl="/"
            appearance={{
              elements: {
                userButtonAvatarBox: 'w-9 h-9 rounded-full',
                userButtonTrigger: 'focus:shadow-none'
              }
            }}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
